import { render, staticRenderFns } from "./StartNextOrder.vue?vue&type=template&id=37862406&"
import script from "./StartNextOrder.vue?vue&type=script&lang=js&"
export * from "./StartNextOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports